import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";


const questionnairePayroll: QuestionnaireFlowType = {
    id: FindingAreasEnum.Payroll,
    name: getFindingAreaDisplayText(FindingAreasEnum.Payroll),
    questions: [
        {
            id: `${FindingAreasEnum.Payroll}:Q1`,
            text: "Are all employees and directors (including non-executive directors) remunerated entirely via payroll subject to income tax and NIC (where relevant) via PAYE?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber
            },
        }
    ]
}

export default questionnairePayroll;